module.exports = __webpack_public_path__ + "static/media/envelope_light.a2bdc005.svg";